import api from "lib/api";

export const getIncomeDeductionList = async (params = {}) => {
  return await api.post(
    "/v1/stpIncomeDeduction/getIncomeDeductionPaging",
    params
  );
};

export const getIncomeDeductionByType = async (params = {}) => {
  return await api.post("/v1/dropdown/getIncomeDeductionByType", params);
};

export const getCommonTypeByGroupType = async (params = {}) => {
  return await api.post("/v1/dropdown/getCommonTypeByGroupType", params);
};
export const getIncomeDeduction = async (params = {}) => {
  return await api.post("/v1/stpIncomeDeduction/getIncomeDeduction", params);
};
export const getIncomeByCompany = async (params = {}) => {
  return await api.post("/v1/stpIncomeDeduction/getIncomeByCompany", params);
};

export const createIncomeDeduction = async (params = {}) => {
  return await api.post("/v1/stpIncomeDeduction/createIncomeDeduction", params);
};
export const createEmploymentType = async (params = {}) => {
  return await api.post("/v1/employmentTypeSetup/createEmploymentTypeSetup", params);
};
export const updateEmploymentType = async (params = {}) => {
  return await api.post("/v1/employmentTypeSetup/updateEmploymentTypeSetup", params);
};

export const updateIncomeDeduction = async (params = {}) => {
  return await api.post("/v1/stpIncomeDeduction/updateIncomeDeduction", params);
};

export const manageStatusIncomeDeduction = async (params = {}) => {
  return await api.post(
    "/v1/stpIncomeDeduction/manageStatusIncomeDeduction",
    params
  );
};
